module.exports = __webpack_public_path__ + "img/gift4-01-c06-t1.d4be6184.png";